import { TableHead, TableRow } from '@material-ui/core';
import React, { useCallback, useContext } from 'react';
import { TableFilterContext } from 'tableFilterContext';
import TableCellHeaderWithConfigurableStyle from './TableCellHeaderWithConfigurableStyle';
import { EntityColumn } from './TableCellWithConfigurableStyle';

interface SortableTableHeadProps {
  columns: EntityColumn[];
}

const SortableTableHead: React.FC<SortableTableHeadProps> = ({ columns }) => {
  const { order, orderBy, dispatch } = useContext(TableFilterContext);

  const createSortHandler = useCallback(
    (property: string) => (event: React.MouseEvent<unknown>) => {
      const isAsc = orderBy === property && order === 'asc';
      dispatch({ type: 'update_order', payload: { orderBy: property, order: isAsc ? 'desc' : 'asc' } });
    },
    [dispatch, order, orderBy],
  );
  return (
    <TableHead>
      <TableRow>
        {columns.map(column => (
          <TableCellHeaderWithConfigurableStyle
            key={column.headerTranslationKey}
            column={column}
            createSortHandler={createSortHandler}
            orderBy={orderBy}
            order={order}
          />
        ))}
      </TableRow>
    </TableHead>
  );
};

export default SortableTableHead;
